import { Injectable } from '@angular/core';
import { type ActivatedRouteSnapshot, Router, type CanActivate } from '@angular/router';
import { BaseGuardChainFacade } from '@medsurf/flat-facades';

@Injectable({
  providedIn: 'root'
})
export abstract class BaseChainBaseGuard implements CanActivate {
  protected constructor(public router: Router,
                        public baseChainGuardFacade: BaseGuardChainFacade) {
  }

  abstract canActivate(next: ActivatedRouteSnapshot): Promise<boolean>;
  
  async requestNavigateToLogin() {
	  await this.router.navigate(['/login']);
	  return true;
  }
}
